import { Location } from '@cobliteam/common-types';

export enum ActivationTasksTypes {
  SCHEDULE_INSTALLATIONS = 'SCHEDULE_INSTALLATIONS',
  INVITE_USERS = 'INVITE_USERS',
  CREATE_VEHICLES = 'CREATE_VEHICLES',
  CREATE_DRIVERS = 'CREATE_DRIVERS',
  ORGANIZE_GROUPS = 'ORGANIZE_GROUPS',
  CONFIGURE_ALERTS = 'CONFIGURE_ALERTS',
  CREATE_GEOFENCES = 'CREATE_GEOFENCES',
  CREATE_CHECKLISTS = 'CREATE_CHECKLISTS',
}

export type Task = {
  i18nKey: string;
  url: string;
  name: ActivationTasksTypes;
  permissions: string[];
  id: string;
};

export type Category = {
  i18nKey: string;
  tasks: Task[];
  image?: string | null;
};

export const BasicSettingsActivationTasks = [
  {
    i18nKey: 'schedule_installations',
    url: Location.CRM_SCHEDULE,
    name: ActivationTasksTypes.SCHEDULE_INSTALLATIONS,
    permissions: ['create-update-delete:crm'],
  },
  {
    i18nKey: 'invite_users',
    url: Location.CONFIG_USERS,
    name: ActivationTasksTypes.INVITE_USERS,
    permissions: ['create-update-delete:users-and-invites'],
  },
  {
    i18nKey: 'create_vehicles',
    url: Location.VEHICLES,
    name: ActivationTasksTypes.CREATE_VEHICLES,
    permissions: ['create-update-delete:vehicle'],
  },
  {
    i18nKey: 'create_drivers',
    url: Location.DRIVER_MANAGEMENT,
    name: ActivationTasksTypes.CREATE_DRIVERS,
    permissions: ['create-update-delete:driver'],
  },
  {
    i18nKey: 'organize_groups',
    url: Location.VEHICLES_GROUPS,
    name: ActivationTasksTypes.ORGANIZE_GROUPS,
    permissions: ['create-update-delete:vehicle'],
  },
];

export const AdvancedSettingsActivationTasks = [
  {
    i18nKey: 'configure_alerts',
    url: Location.FLEET_POLICY,
    name: ActivationTasksTypes.CONFIGURE_ALERTS,
    permissions: ['config-and-view:custom-alerts'],
  },
  {
    i18nKey: 'create_geofences',
    url: Location.GEOFENCES,
    name: ActivationTasksTypes.CREATE_GEOFENCES,
    permissions: ['create-update-delete:places-of-interest'],
  },
  {
    i18nKey: 'create_checklists',
    url: Location.CHECKLIST,
    name: ActivationTasksTypes.CREATE_CHECKLISTS,
    permissions: ['full-control:checklist'],
  },
];
